/**
 * author: omarg
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var ApiResources = require("assets/data/apiResources.json");

    // UTILS
    var RegistrationStorageUtil = require("registration-utils/RegistrationStorageUtil");

    var BillingPricingModel = {};
    LE.module('LERegistration', function (LERegistration, LE, Backbone, Marionette, $, _) {

        BillingPricingModel = BaseModel.extend({
            name: "BillingPricingModel",
            fetch: function(options){
                var url = _.clone(ApiResources.Billing.BillingPricingCurrent).url;
                var productName= RegistrationStorageUtil.CONSTANT.DEFAULT_PRODUCT_NAME;
                var planName= options && options.planName;
                if(planName){
                    url = _.clone(ApiResources.Billing.BillingPricing).url;
                    url = url.replace("{productName}", encodeURIComponent(productName));
                    url = url.replace("{planName}", encodeURIComponent(planName));
                }else{
                    url = url.replace("{accountId}", LE.loginInfo.accountId);
                }

                this.resource = {url: url};

                options = options || {};
                options.headers = {
                    'Accept': 'application/json'
                };
                BaseModel.prototype.fetch.call(this, options);
            }
        });
    });

    return BillingPricingModel;
});
